import {TRANSPORTER_NAME , TRANSPOTER_GSTIN} from "./company"


const USE_OVERLAY = true;
const SHOW_AMC_POPUP = 1;

// TEMP (testing): 10 seconds so the repeat can be seen quickly.
// Restore to 60 * 60 * 1000 (1 hour) before commit.
// const AMC_POPUP_INTERVAL_MS = 10 * 1000;

const AMC_POPUP_INTERVAL_MS = 60 * 60 * 1000;

// sessionStorage key holding the timestamp (Date.now()) of the last AMC popup shown
const AMC_POPUP_LAST_SHOWN_KEY = "amc_popup_last_shown";

const getLocalFlag = () => {
    try{
        let lo = localStorage.getItem("local_flag") === 'true';
        console.log("Inansdsnns", lo);
      return lo
    } catch(e){
      return false
    }
  }
var SERVER_URL = ""
if (getLocalFlag()){
    console.log("in if")
    // SERVER_URL = "http://103.180.39.155:8001";
    // SERVER_URL = SERVER_URL_CMP
    SERVER_URL ="https://backend.veerexp.in"
  }
else{
    console.log("in else")
    SERVER_URL ="https://backend.veerexp.in"
    // SERVER_URL = "http://103.180.39.155:8001";
    // SERVER_URL = SERVER_URL_CMP
    // SERVER_URL = `http://${SERVER_IP}:${SERVER_PORT}`;
    // const SERVER_URL = "https://d7edf369be0e55.localhost.run";
}

var UTILITY_SERVER_URL =  "https://print.veerexp.in";

console.log(SERVER_URL)
export { SERVER_URL, USE_OVERLAY, SHOW_AMC_POPUP, AMC_POPUP_INTERVAL_MS, AMC_POPUP_LAST_SHOWN_KEY, TRANSPORTER_NAME, TRANSPOTER_GSTIN, UTILITY_SERVER_URL };
